<h2 mat-dialog-title>Ratios of images do not match!</h2>
<mat-dialog-content class="mat-typography">
  <h3>Are you sure you want to replace the original image with an image which's ratio is different?</h3>
  <p>The image will probably be distorted.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Cancel</button>
  <button mat-button [mat-dialog-close]="true">Replace anyway</button>
</mat-dialog-actions>
